const FrontendBody = (props) => {
  const { element } = props;
  return (
    <>
      {element}
    </>
  )
}

export default FrontendBody
